import { makeStyles } from 'tss-react/mui'
import { fundingColors as C } from '../../theme/fundingColors'
import { fundingFont } from '../../theme/fundingTypography'

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column' as const,
    border: `1px solid ${C.separator}`,
    borderRadius: 12,
    overflow: 'hidden',
    backgroundColor: C.cardBg,
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(1),
  },
  error: {
    padding: theme.spacing(1, 2, 0),
    fontFamily: fundingFont,
    fontSize: 12,
    lineHeight: '16px',
    color: theme.palette.error.main,
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(1.5, 2),
    borderTop: `1px solid ${C.separator}`,
  },
  arr: {
    display: 'flex',
    alignItems: 'baseline',
    gap: theme.spacing(1),
    marginRight: 'auto',
  },
  arrLabel: {
    fontFamily: fundingFont,
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '16px',
    color: C.mutedText,
  },
  arrValue: {
    fontFamily: fundingFont,
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px',
    color: C.strongText,
    fontVariantNumeric: 'tabular-nums',
  },
}))
